import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import styled, { css } from 'styled-components';

import Text from 'components/Text';
import Stack from 'components/Stack';
import Icon from 'components/Icon';
import Link from 'components/Link';

import { color, media, variants } from 'styles/utils';

const StyledCard = styled.div`
  background-color: ${color('white')};
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${variants({
    dark: css`
      background-color: #344054;
      color: #fff;
    `,
    default: css`
      background-color: ${color('white')};
      color: ${color('textTeal')};

      h5 {
        color: ${color('darkTeal')};
      }
    `,
  })}
`;

const CardDetails = styled(Stack)`
  flex: 1;
  padding: 1.5rem;
  text-align: left;
`;

const StyledDescription = styled(Text)`
  min-height: 13rem;

  ${media.max('md')} {
    min-height: auto;
  }
`;

const Name = styled(Text)`
  margin: 0 0 0.5rem 0;
`;

export default function FounderCard({
  description,
  link,
  name,
  profile,
  title,
  variant = 'default',
}) {
  return (
    <StyledCard $variant={variant}>
      <GatsbyImage alt={`Photograph of ${name}`} image={getImage(profile)} />
      <CardDetails gap="1rem">
        <div>
          <Name forwardedAs="h5" variant="f5">
            {name}
          </Name>
          <Text variant="smallestP">{title}</Text>
        </div>
        <StyledDescription variant="smallP">{description}</StyledDescription>
        <Link href={link}>
          <Icon name="linkedin" size="xl" />
        </Link>
      </CardDetails>
    </StyledCard>
  );
}

FounderCard.propTypes = {
  description: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['default', 'dark']),
};
